export const replaceAllPercentageSymbols = (value: string) => `${value.replaceAll('%', '')}%`;
